import { connect } from 'react-redux'
import App from './app.js'
import { featureActions } from '../features'
import {
    actionAutoLaunchOnStartup,
    actionUpdateAutoLaunchOnStartup,
    actionAppSetAutoLaunchEnabledState,
} from '../actions'
import { selectors } from '../features/Settings'
import { launcherJavaScriptReady } from '../launcherBackend'
import { actions as toasterActions } from '../features/Toaster'

function mapStateToProps(state) {
    const { app, profile } = state
    return {
        showProfileSelector: profile.open,
        showSettings: app.showSettings,
        isAutoLaunchEnabled: () => actionAutoLaunchOnStartup(),
        setAutoLaunchUrlParameter: () => actionUpdateAutoLaunchOnStartup(),
        server: state.servers.active,
        locale: selectors.getLanguage(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        languageSet: (locale) => {
            dispatch(featureActions.languageChanged(locale))
        },
        setAutoLaunchEnabledState: (enabled) => {
            dispatch(actionAppSetAutoLaunchEnabledState(enabled))
        },
        javaScriptReady: (server) => {
            launcherJavaScriptReady(server)
        },
        actionNotifyMotd: (motd) => {
            dispatch(toasterActions.addMessage(motd))
        },
        actionNotifySuccess: (message) => {
            dispatch(toasterActions.addSuccess(message))
        },
        actionNotifyInfo: (message) => {
            dispatch(toasterActions.addInfo(message))
        },
        actionNotifyError: (message) => {
            dispatch(toasterActions.addError(message))
        },
        actionNotifyWarning: (message) => {
            dispatch(toasterActions.addWarning(message))
        },
    }
}

function mergeProps(stateProps, dispatchProps) {
    return {
        showProfileSelector: stateProps.showProfileSelector,
        showSettings: stateProps.showSettings,
        isAutoLaunchEnabled: stateProps.isAutoLaunchEnabled,
        setAutoLaunchUrlParameter: stateProps.setAutoLaunchUrlParameter,
        languageSet: () => {
            dispatchProps.languageSet(stateProps.locale)
        },
        setAutoLaunchEnabledState: dispatchProps.setAutoLaunchEnabledState,
        javaScriptReady: () => {
            launcherJavaScriptReady(stateProps.server)
        },
        actionNotifyError: dispatchProps.actionNotifyError,
        actionNotifyWarning: dispatchProps.actionNotifyWarning,
        actionNotifySuccess: dispatchProps.actionNotifySuccess,
        actionNotifyInfo: dispatchProps.actionNotifyInfo,
        actionNotifyMotd: dispatchProps.actionNotifyMotd,
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(App)



// WEBPACK FOOTER //
// ./src/App/app-container.js